<template>
  <div class="brand-creator-page">
    <BrandTool :active-tab="1">
      <div class="brand-creator">
        <div class="brand-creator__inputs-row">
          <FormulateInput
              type="text"
              autocomplete="off"
              v-model="currentProject.label"
              @input="konstruktorNameChangeHandler"
              name="Project name"
              label="Project name"
              :class="['brand-creator__input-wrapper']"
              :label-class="['formulate-input-label--tool-label']"
              :element-class="['formulate-input-element--tool-text', 'brand-creator__input-element', 'brand-creator__input-element--lock']"
              :error="this.formErrors.currentProject.error ? this.formErrors.currentProject.text : null"
              :readonly="currentProject.value ? true : false"
          >
            <template #suffix>
              <div class="input-locked-status" v-if="currentProject.value">
                <InlineSvg :src="require(`../../assets/svgs/close.svg`)" @click="clearProject"
                           class="icon icon--red"/>
              </div>
            </template>
          </FormulateInput>
        </div>
        <div class="brand-creator__inputs-row">
          <FormulateInput
              type="text"
              autocomplete="off"
              v-model="projectDescription.label"
              @input="konstruktorDescriptionChangeHandler"
              name="Project description"
              label="Project description"
              :class="['brand-creator__input-wrapper']"
              :label-class="['formulate-input-label--tool-label']"
              :element-class="['formulate-input-element--tool-text', 'brand-creator__input-element', 'brand-creator__input-element--lock']"
              :error="this.formErrors.projectDescription.error ? this.formErrors.projectDescription.text : null"
              :readonly="projectDescription.value ? true : false"
          >
          </FormulateInput>

          <SearchWordInput
              label="Enter a word to search with below..."
              :class="['brand-creator__input-wrapper', 'brand-creator__drag-drop-input']"
              :search-word-form-error="formErrors.konstruktorWord"
              @value-updated="updateWordSearchValue"
          />
        </div>

        <CreatorSearchOptions
            :search-form-error="formErrors.searchOption"
            @search-options-updated="updateSearchOptions"
            @update-selected-language="updateSelectedLanguage"
            @search-triggered="searchForWords"
            :searchDisabled="searchDisabled"
            :konstruktor_word="konstruktor_word"
        />

        <CreatorSearchResults
            @wordbank-updated="updateWordbank"
            :data="this.searchResultData"
            :searchID="this.searchID"
        />

        <CreatorLoadingProgress
            v-if="this.isSearching"
            :percentage="this.searchPercentage"
            :search-options="this.searchOptions"
        />

        <div class="timeout-warning" v-if="timeOut">
          <p>Oh no! Looks like something has gone wrong. Please try your search again or contact us.</p>
        </div>

        <router-link v-if="wordBankWords.length >= 3" to="/brand-checker" class="btn">Check Your Brand Name
        </router-link>
      </div>
    </BrandTool>

    <CallToAction :button-text="'Click here to view our different pricing models'" :button-link="'/our-packages'"
                  :copy="'Which Khonsu Plan is best for me?'"/>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import BrandTool from "@/components/layout/BrandTool";
import CallToAction from "@/components/layout/CallToAction";
import userMixin from "../../mixins/userMixin";
import CreatorSearchOptions from "@/views/BrandCreator/CreatorSearchOptions";
import CreatorSearchResults from "@/views/BrandCreator/CreatorSearchResults";
import CreatorLoadingProgress from "@/views/BrandCreator/CreatorLoadingProgress";
import SearchWordInput from "@/views/BrandCreator/SearchWordInput";
import axios from "axios";
import InlineSvg from "vue-inline-svg";

export default {
  name: 'BrandCreator',
  metaInfo: {
    title: 'Khonsu - Brand Creator'
  },
  components: {
    CreatorSearchOptions,
    BrandTool,
    CallToAction,
    CreatorSearchResults,
    CreatorLoadingProgress,
    SearchWordInput,
    InlineSvg
  },
  computed: {
    ...mapGetters([
      'brandKonstruktorStep',
    ]),
    activeTab: function () {
      if (this.activeTabIndex > 0) {
        if (this.activeTabIndex == 1 && this.islike_result_ready) {
          return true;
        } else if (this.activeTabIndex == 2 && this.soundlike_result_ready) {
          return true;
        } else if (this.activeTabIndex == 3 && this.describelike_result_ready) {
          return true;
        } else if (this.activeTabIndex == 4 && this.abbreviate_it_result_ready) {
          return true;
        } else if (this.activeTabIndex == 5 && this.foriegnize_it_result_ready) {
          return true;
        } else if (this.activeTabIndex == 6 && this.urbanize_it_result_ready) {
          return true;
        }
      }

      return false;
    },
    ...mapGetters('BrandCentre', {
      currentProject: 'getCurrentProject',
      projectDescription: 'getProjectDescription',
      availableProjects: 'getAvailableProject',
      wordBankWords: 'getWordBankWords',
    }),
    ...mapGetters('BrandCreator', {
      searchWord: 'getSearchWordString',
    }),
  },
  data() {
    return {
      konstruktor_word: '',
      activeTabIndex: 0,
      formErrors: {
        currentProject: {
          error: false,
          text: 'Project name is required'
        },
        projectDescription: {
          error: false,
          text: 'Project description is required'
        },
        konstruktorWord: {
          error: false,
          text: 'Search word is required'
        },
        searchOption: {
          error: false,
          text: "Please select a search term"
        }
      },
      language: 'EN',
      searchOptions: [],
      WordbankWords: [],
      searchResultData: {},
      portmanteauResult: {},
      isSearching: false,
      searchPercentage: 0,
      searchID: 0,
      searchDisabled: 0,
      timeOut: false
    }
  },
  methods: {
    ...mapActions('BrandCentre', [
      'clearSelectedProject'
    ]),
    ...mapActions('BrandCreator', [
      'resetSearchWordPills'
    ]),
    ...mapActions('BrandChecker', [
      'resetBrandNamePills'
    ]),
    konstruktorNameChangeHandler: function () {
      if (!this.currentProject.label || this.currentProject.label.trim().length === 0) {
        return;
      }
      this.formErrors.currentProject.error = false;
    },
    konstruktorDescriptionChangeHandler: function () {
      if (!this.projectDescription.label || this.projectDescription.label.trim().length === 0) {
        return;
      }
      this.formErrors.projectDescription.error = false;
    },
    updateSearchOptions(data) {
      this.searchOptions = data;
    },
    updateSelectedLanguage(data) {
      this.language = data;
    },
    validateForm() {
      if (!this.currentProject.label) {
        this.formErrors.currentProject.error = true;
        return false;
      }

      if (!this.projectDescription.label) {
        this.formErrors.projectDescription.error = true;
        return false;
      }

      if (!this.konstruktor_word) {
        this.formErrors.konstruktorWord.error = true;
        return false;
      }

      if (this.searchOptions.length <= 0) {
        this.formErrors.searchOption.error = true;
        return false;
      }

      return true;
    },
    async searchForWords() {
      if (!this.validateForm()) {
        return false;
      }

      this.searchResultData = {}
      this.searchID = 0

      // if the project name doesn't already exist then we call the function to create the project, if it does exist we set the current project in the brand centre
      if (!this.availableProjects.some(project => project.label.toLowerCase() === this.currentProject.label.trim().toLowerCase())) {
        this.$store.dispatch('BrandCentre/createProject', this.currentProject.label.trim());
      } else {
        const project = this.availableProjects.find(project => project.label.toLowerCase() === this.currentProject.label.trim().toLowerCase());
        this.$store.dispatch('BrandCentre/changeCurrentProject', project.value);
      }

      this.isSearching = true
      this.searchDisabled = 1 // Stops the search button being pressed twice

      let result = {data: null};
      // Performs the rest of the searches which don't have seperate endpoints
      if (this.searchOptions.filter(e => e !== 'portmanteau').length != 0) {
        let payload = {
          "project_name": this.currentProject.label,
          "project_description": this.projectDescription.label,
          "job_type": this.searchOptions.filter(e => e !== 'portmanteau'),
          "language": this.language,
          "keyword": this.konstruktor_word,
        }

        result = await axios.post(`${process.env.VUE_APP_API_ROOT_URL}/api/brand/create`, JSON.stringify(payload), {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${userMixin.methods.getUserToken()}`,
          }
        });

        this.searchResultData = result.data;
      }

      this.isSearching = false;
      this.searchDisabled = 0;
      this.timeOut = false;

    },
    updateWordbank(data) {
      this.WordbankWords = data;
    },
    updateWordSearchValue(value) {
      this.konstruktor_word = value;

      if (this.konstruktor_word) {
        this.formErrors.konstruktorWord.error = false;
      }
    },
    clearProject() {
      this.clearSelectedProject();
      this.resetSearchWordPills();
      this.resetBrandNamePills();
      this.searchResultData = {};
    }
  },
  mounted() {
    this.$store.dispatch('BrandKonstrucktorWordBank/getuserwordExist', {"user_id": sessionStorage.getItem('user_id'),});
    this.$store.dispatch('BrandCentre/getProjects');

    if (this.searchWord) {
      this.konstruktor_word = this.searchWord;
    }
  },
}
</script>
